import './App.css';
import { configureAxiosDefaults } from './axios_config';

function App() {
  configureAxiosDefaults();
  return <div></div>;
}

export default App;
